import membersGroupRowUrl from './membersGroupRow.html';

class MembersGroupRowCtrl {
  constructor(PersonaCollection) {
    'ngInject';

    this.personasDict = PersonaCollection.personasDict;
  }
}

export default {
  controller: MembersGroupRowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    group: '<',
  },
  templateUrl: membersGroupRowUrl,
};
